module.exports = __webpack_public_path__ + "c9325c38e6f2c78e11915f4f31cf45aa.pdf";